import { useState } from "react"
import { H2 } from "components/ui/typography/titles/Titles"
import { CompetitorsCollapse } from "./layout/CompetitorsCollapse/CompetitorsCollapse"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { AddCompetitorModal } from "./layout/AddCompetitorModal/AddCompetitorModal"
import style from "./CompetitorsModelNumbers.module.scss"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { AddModelNumberModal } from "./layout/AddModelNumberModal/AddModelNumberModal"

const { competitorsModelNumbers, topBlock, buttonsWrapper } = style

export const CompetitorsModelNumbers = () => {
	const [isCompetitorModalOpen, setCompetitorModalOpen] = useState(false)
	const [isModelNumberModalOpen, setModelNumberModalOpen] = useState(false)

	return (
		<>
			<div className={competitorsModelNumbers}>
				<div className={topBlock}>
					<H2>Competitors model numbers</H2>
					<div className={buttonsWrapper}>
						<ButtonSecondary onClick={() => setCompetitorModalOpen(true)}>Add competitor</ButtonSecondary>
						<ButtonPrimary onClick={() => setModelNumberModalOpen(true)}>Add model number</ButtonPrimary>
					</div>
				</div>
				<CompetitorsCollapse />
			</div>
			<AddCompetitorModal isModalOpen={isCompetitorModalOpen} setModalClose={() => setCompetitorModalOpen(false)} />
			<AddModelNumberModal isModalOpen={isModelNumberModalOpen} setModalClose={() => setModelNumberModalOpen(false)} />
		</>
	)
}
